import Button from '@mui/material/Button'

export const SigninButton = ({ label, disabled, onClick, className }) => {
  return (
    <Button
      type="submit"
      fullWidth
      variant="contained"
      sx={{ mt: 3, mb: 2 }}
      disabled={disabled}
      onClick={onClick}
      className={className}
      data-testid="Button-ada51164-036b-432b-8b53-2192848f4125"
    >
      {label}
    </Button>
  )
}

export const BackToLoginButton = ({ label, className, onClick }) => {
  return (
    <Button
      className={className}
      onClick={onClick}
      type="button"
      fullWidth
      variant="contained"
      sx={{ mt: 3, mb: 2 }}
      data-testid="Button-fe831f4d-8f5e-4f2f-8513-27aa90d2c38d"
    >
      {label}
    </Button>
  )
}

export const SigninSignupButton = ({ label, className, onClick }) => {
  return (
    <Button
      className={className}
      onClick={onClick}
      type="button"
      size="small"
      variant="contained"
      sx={{ mr: 2 }}
      data-testid="Button-046f5922-159c-4eb6-b449-9601db57f9ec"
    >
      {label}
    </Button>
  )
}
